module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [_c('div', {
    staticClass: "step-form__step-num"
  }, [_vm._v("1/5")]), _vm._v(" "), _c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v("我要贷款")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "step1Form",
    staticClass: "step-form__form",
    attrs: {
      "label-width": '50%',
      "model": _vm.step1Form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "贷款产品",
      "prop": "loanProduct"
    }
  }, [_c('el-select', {
    ref: "loanProduct",
    attrs: {
      "disabled": true,
      "filterable": "",
      "remote": "",
      "placeholder": "请选择贷款产品"
    },
    on: {
      "change": _vm.autoSelectProductAndRepayType
    },
    model: {
      value: (_vm.step1Form.loanProduct),
      callback: function($$v) {
        _vm.$set(_vm.step1Form, "loanProduct", $$v)
      },
      expression: "step1Form.loanProduct"
    }
  }, _vm._l((_vm.initialData.loanProductList), function(item) {
    return _c('el-option', {
      key: item.productId,
      attrs: {
        "label": item.productName,
        "value": item.productId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "贷款金额",
      "prop": "loanAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入贷款金额"
    },
    on: {
      "blur": function($event) {
        return _vm.inputBlurFn('loanAmount')
      }
    },
    model: {
      value: (_vm.step1Form.loanAmount),
      callback: function($$v) {
        _vm.$set(_vm.step1Form, "loanAmount", $$v)
      },
      expression: "step1Form.loanAmount"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-form__form-item-unit"
  }, [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "step-form__form-item--with-unit step-form-repayType",
    attrs: {
      "label": "还款方式",
      "prop": "repayType"
    }
  }, [_c('el-select', {
    ref: "repayType",
    attrs: {
      "placeholder": "请选择还款方式"
    },
    model: {
      value: (_vm.step1Form.repayType),
      callback: function($$v) {
        _vm.$set(_vm.step1Form, "repayType", $$v)
      },
      expression: "step1Form.repayType"
    }
  }, _vm._l((_vm.initialData.repayTypeList), function(item) {
    return _c('el-option', {
      key: item.baseProductRepay,
      attrs: {
        "label": item.baseProductRepayName,
        "value": item.baseProductRepay
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "贷款期限",
      "prop": "loanLimit"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入贷款期限",
      "maxlength": 5
    },
    on: {
      "blur": function($event) {
        return _vm.inputBlurFn('loanLimit')
      }
    },
    model: {
      value: (_vm.step1Form.loanLimit),
      callback: function($$v) {
        _vm.$set(_vm.step1Form, "loanLimit", $$v)
      },
      expression: "step1Form.loanLimit"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-form__form-item-unit"
  }, [_vm._v(_vm._s(_vm.selectedTimeUnit.text))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "protocol_cont contract_error",
    attrs: {
      "prop": "hasReadContract"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.step1Form.hasReadContract),
      callback: function($$v) {
        _vm.$set(_vm.step1Form, "hasReadContract", $$v)
      },
      expression: "step1Form.hasReadContract"
    }
  }, [_c('el-checkbox', {
    staticClass: "step1__has-read-loan-contract",
    attrs: {
      "label": "我已阅读并同意"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "step1__show-loan-contract step1__show-loan-contract2",
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "prev", undefined, $event.key, undefined)) { return null; }
        return _vm.showLoanContract($event)
      }
    }
  }, [_vm._v("《贷款协议》")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("下一步")])])], 1), _vm._v(" "), (_vm.confirmLoanData) ? _c('el-dialog', {
    staticClass: "confirm-loan dialog",
    attrs: {
      "visible": _vm.confirmLoanData.show,
      "before-close": _vm.cancelLoan,
      "close-on-click-modal": false
    }
  }, [_c('h4', {
    staticClass: "confirm-loan__dialog-title dialog__title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("确认贷款信息")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-loan__loan-info"
  }, [_c('el-row', {
    staticClass: "confirm-loan__loan-info-row",
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    staticClass: "confirm-loan__info--label",
    attrs: {
      "span": 3
    }
  }, [_vm._v("贷款产品")]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--content",
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.confirmLoanData.data.productName))]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--label",
    attrs: {
      "span": 3
    }
  }, [_vm._v("贷款期限")]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--content",
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.confirmLoanData.data.expires) + _vm._s(_vm.selectedTimeUnit.text))]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--label",
    attrs: {
      "span": 3
    }
  }, [_vm._v("年化利率")]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--content",
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.confirmLoanData.data.yearRate) + "%")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "confirm-loan__loan-info-row",
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    staticClass: "confirm-loan__info--label",
    attrs: {
      "span": 3
    }
  }, [_vm._v("贷款金额")]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--content",
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm._f("addThousandSign")(_vm.confirmLoanData.data.money, 2)) + "元\n        ")]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--label",
    attrs: {
      "span": 3
    }
  }, [_vm._v("还款方式")]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--content",
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.confirmLoanData.data.repayTypeName))]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--label",
    attrs: {
      "span": 3
    }
  }, [_vm._v("贷款利息")]), _vm._v(" "), _c('el-col', {
    staticClass: "confirm-loan__info--content",
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("addThousandSign")(_vm.confirmLoanData.data.interestMoney, 2)) + "元\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "confirm-loan__repay-plan"
  }, [_c('h5', {
    staticClass: "confirm-loan__repay-plan-title dialog__title"
  }, [_vm._v("我的还款计划")]), _vm._v(" "), _c('table', {
    staticClass: "confirm-loan__repay-plan-table"
  }), _vm._v(" "), _c('el-table', {
    staticClass: "confirm-loan__repay-plan-table",
    staticStyle: {
      "width": "846px"
    },
    attrs: {
      "border": "",
      "data": _vm.confirmLoanData.data.planlist,
      "fit": "",
      "stripe": "",
      "max-height": "232"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "期数",
      "width": "54px",
      "align": "center",
      "resizable": _vm.isResizable
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "confirm-loan__repay-plan__periods"
        }, [_vm._v(_vm._s(scope.row.period))])]
      }
    }], null, false, 4243145889)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "本金/元",
      "min-width": "290px",
      "align": "center",
      "resizable": _vm.isResizable
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("addThousandSign")(scope.row.moneybj, 2)) + "\n          ")]
      }
    }], null, false, 4087966606)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "利息/元",
      "min-width": "260px",
      "align": "center",
      "resizable": _vm.isResizable
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("addThousandSign")(scope.row.moneylx, 2)) + "\n          ")]
      }
    }], null, false, 1057052242)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "还款日期",
      "width": "220px",
      "align": "center",
      "resizable": _vm.isResizable
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("formatDate")(scope.row.date, 'YYYY-MM-DD')) + "\n          ")]
      }
    }], null, false, 3933939179)
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "dialog__footer__confirm-btn",
    attrs: {
      "loading": _vm.isSubmitting
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("确定")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b354b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/Step1_bak.vue
// module id = 1059
// module chunks = 1